/*
 * Empirical Health — automatic standard cart quantity updates
 * Custom-formula quantities continue to use cart-line-items.liquid.
 */

(function () {
  'use strict';

  var updating = false;

  function isStandardQuantityInput(element) {
    return (
      element instanceof HTMLInputElement &&
      element.hasAttribute('data-update-cart') &&
      element.hasAttribute('data-quantity-input') &&
      !element.closest('[data-eh-formula-row]')
    );
  }

  function disableCartControls(disabled) {
    document
      .querySelectorAll(
        '[data-increase-quantity], ' +
        '[data-decrease-quantity], ' +
        '.checkout__button, ' +
        '#bss-checkout, ' +
        '[data-eh-native-checkout]'
      )
      .forEach(function (control) {
        control.disabled = disabled;
      });
  }

  async function updateStandardCartLine(input) {
    if (updating || !isStandardQuantityInput(input)) {
      return;
    }

    var itemKey = input.getAttribute('data-update-cart');
    var quantity = parseInt(input.value, 10);

    if (!itemKey || !Number.isFinite(quantity)) {
      return;
    }

    quantity = Math.max(0, quantity);
    updating = true;
    disableCartControls(true);

    try {
      var root =
        window.Shopify &&
        window.Shopify.routes &&
        window.Shopify.routes.root
          ? window.Shopify.routes.root
          : '/';

      var response = await fetch(root + 'cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          id: itemKey,
          quantity: quantity
        })
      });

      var result = await response.json();

      if (!response.ok) {
        throw new Error(
          result.description ||
          result.message ||
          'The cart quantity could not be updated.'
        );
      }

      window.location.reload();
    } catch (error) {
      console.error('Cart quantity update failed:', error);
      updating = false;
      disableCartControls(false);
      window.alert(
        error.message ||
        'The cart quantity could not be updated. Please try again.'
      );
    }
  }

  /*
   * Pipeline changes the input value and then emits a change event.
   * Capture that event before another script reloads the old cart state.
   */
  document.addEventListener(
    'change',
    function (event) {
      if (!isStandardQuantityInput(event.target)) {
        return;
      }

      event.stopImmediatePropagation();
      updateStandardCartLine(event.target);
    },
    true
  );

  document.addEventListener(
    'keydown',
    function (event) {
      if (
        event.key !== 'Enter' ||
        !isStandardQuantityInput(event.target)
      ) {
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();
      updateStandardCartLine(event.target);
    },
    true
  );
})();